import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Copylink extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Copylink',
    refs: ['btn'],
  };

  /**
   * On btn click
   * @returns {void}
   */
  onBtnClick() {
    navigator.clipboard.writeText(this.$refs.getAttribute('href')).then();
  }
}
